import React, {useState} from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { useDataContext } from "../../contexts/DataContext";
import { useNavigate } from "react-router-dom";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import AssistantDirectionIcon from "@mui/icons-material/AssistantDirection";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyIcon from '@mui/icons-material/Key';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import '../Reschedule';
import { req } from "../../utils";
import { resolveMachineById } from "../../utils/jobMachines";
import Reschedule from "../Reschedule";
const ListViewItem = ({ call }) => {
  let navigate = useNavigate();
  const { jobs, machines, isAdmin, technicians } = useDataContext();
  const [isAccessNotesExpanded, setIsAccessNotesExpanded] = useState(false);
  const handleClick = (url) => {
    navigate(url);
  };
  const cancelPm = (call) => {
    //console.log("Cancel PM", call);
    if (
      window.confirm(
        "Are you sure you want to cancel this preventative maintenance?"
      )
    ) {
      //Cancel PM
      req("POST", "cancel_pm", {
        service_call_id: call.service_call_id,
        venue_id: call.service_venue_id,
      }).then((res) => {
        if (res) {
          alert("Preventative maintenance has been canceled.");
          window.location.reload();
        }
      });
    }
  };
  const buildAppleMapsLink = (latitude, longitude) => {
    return `https://maps.apple.com/?daddr=${latitude},${longitude}`;
  };

  const isTextLong = (text, maxLength = 50) => {
    return text && text.length > maxLength;
  };
 
  const getCallLocation = (call) => {
    let job = jobs.find(
      (j) => String(j?.service_call_id) === String(call.service_call_id)
    );
    let jobMachines = job?.machine_ids_array;
    if (Array.isArray(jobMachines) && jobMachines.length > 0) {
      const venuePayload = job?.venue_machines ?? call?.venue_machines;
      const jobMachine = resolveMachineById(
        jobMachines[0],
        machines,
        venuePayload
      );
      if (jobMachine) {
        return (
          <div style={{ fontWeight: "bolder" }}>
            <GpsFixedIcon
              sx={{ fontSize: "14px", marginRight: "5px" }}
              color="persiangreen"
            >
              {" "}
            </GpsFixedIcon>
            {jobMachine.location}
          </div>
        );
      }
    }
    return <>No location found</>;
  };
  const getMachineSerialText = () => {
    let returnValue = "";
    //if machine ids are in the call
    if (call.machine_ids_array && call.machine_ids_array.length > 0) {
      returnValue =
        call.machine_ids_array.length > 1 ? "Machines: " : "Machine: ";
      for (let i = 0; i < call.machine_ids_array.length; i++) {
        const machine = resolveMachineById(
          call.machine_ids_array[i],
          machines,
          call.venue_machines
        );
        if (machine) {
          returnValue += machine.serial_id;
          if (i < call.machine_ids_array.length - 1) {
            returnValue += ", ";
          }
        }
      }
      return returnValue;
    }
    return null;
  };
  let assinged_user = call?.assigned_to_name;
  if (!assinged_user && Array.isArray(technicians) && technicians.length > 0) {
    const assignedTech = technicians.find((tech) => String(tech.account_id) === String(call?.assigned_to || call?.tech_id));
    assinged_user = assignedTech?.name || assignedTech?.full_name || assignedTech?.first_name;
  }
  if (!assinged_user) assinged_user = "#" + (call?.assigned_to || call?.tech_id || "unassigned");
  if(String(call?.service_call_id) ==="93"){
    console.log("DEBUGGING ", call?.status?.toLowerCase(),(call?.status?.toLowerCase() !== "completed" || call?.status?.toLowerCase() !=='rescheduled'),call?.status?.toLowerCase() !== "completed",call?.status?.toLowerCase() !=='rescheduled');
  }
  return (
    <div
      key={call.tech_run_stop_id}
      onClick={(e) => {
        handleClick(`/call/${call.service_call_id}`);
        e.stopPropagation();
      }}
      className={`schedule-list--row highlight-${call?.highlight}`}
    >
        <div className="col-time flex">
          {call.time ? call.time.replace(/:00$/, "") : "No Time"}
          <span style={{ margin: "0 .25rem" }}>-</span>
          <span>
            {call.service_call_type ?? "No call type"}
            <br />
            Status:{" "}
            {call.status ? (
            <span style={{ textTransform: "uppercase" }}>{call.status}</span>
            ) : (
            "No call status"
            )}
          </span>
        </div>
        <div className="col-type">
          {call.service_call_type ?? "No call type"}
          <div>
            Status:{" "}
            {call.status ? (
            <span style={{ textTransform: "uppercase" }}>{call.status}</span>
            ) : (
            "No call status"
            )}
          </div>
        </div>
        <div className="col-venue">
          {call.venue_name ?? "No Venue"}
          <br />
          <div className="text-muted font-smaller">
            {call.address ? (
            <>
              {call.address}
              <div>
                {call.suburb}, {call.postal_code}
              </div>
              {getCallLocation(call)}
              {call.access_notes && (
                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                  <KeyIcon style={{ color: '#666', fontSize: 14, marginRight: 4 }} titleAccess="Access Notes" />
                  <span style={{ fontSize: 12, color: '#666' }}>
                    {isTextLong(call.access_notes) && !isAccessNotesExpanded ? (
                      <Button
                        size="small"
                        variant="text"
                        style={{ 
                          padding: 0, 
                          minWidth: 'auto', 
                          textTransform: 'none',
                          justifyContent: 'flex-start',
                          textAlign: 'left'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsAccessNotesExpanded(true);
                        }}
                      >
                        {call.access_notes.substring(0, 50)}...
                        <ExpandMoreIcon style={{ fontSize: 14, marginLeft: 4 }} />
                      </Button>
                    ) : (
                      <div>
                        {call.access_notes}
                        {isTextLong(call.access_notes) && isAccessNotesExpanded && (
                          <Button
                            size="small"
                            variant="text"
                            style={{ 
                              padding: 0, 
                              minWidth: 'auto', 
                              textTransform: 'none',
                              justifyContent: 'flex-start',
                              textAlign: 'left',
                              marginLeft: 4
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsAccessNotesExpanded(false);
                            }}
                          >
                            <ExpandLessIcon style={{ fontSize: 14 }} />
                          </Button>
                        )}
                      </div>
                    )}
                  </span>
                </div>
              )}
              {(call.saf_id || call.saf_data) && (
                <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                  <CheckCircleIcon style={{ color: '#00A49B', fontSize: 18, marginRight: 4 }} titleAccess="Site Audit Form (SAF) attached" />
                  <span style={{ fontWeight: 500, color: '#00A49B', fontSize: 13 }}>SAF</span>
                  {call.saf_access_pin && (
                    <span style={{ marginLeft: 8, color: '#333', fontSize: 13 }}>
                      <b>PIN:</b> {call.saf_access_pin}
                    </span>
                  )}
                </span>
              )}
            </>
            ) : (
            "No address"
            )}
            <div>
            <Button
              size="small"
              variant="text"
              style={{ paddingLeft: "0px", marginLeft: "0px" }}
              color="persiangreen"
              component="a"
              href={buildAppleMapsLink(call?.latitude, call?.longitude)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <AssistantDirectionIcon
                style={{ fontSize: "16px", marginRight: "5px" }}
              />{" "}
              Apple Maps
            </Button>
            </div>
          </div>
          <div>{getMachineSerialText()}</div>
        </div>
        <div className="col-contact">
          {call?.contact_name}
          {call.contact_phone && (
            <div>
            <Link
              to={`tel:${call.contact_phone}`}
              onClick={(e) => e.stopPropagation()}
            >
              {call.contact_phone}
            </Link>
            </div>
          )}
          {call.contact_email && (
            <div>
            {call.contact_email.includes(",") ? (
              call.contact_email.split(",").map((email) => (
                <div key={email}>
                <Link
                  target="_blank"
                  to={`mailto:${email}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  {email}
                </Link>
                </div>
              ))
            ) : (
              <Link
                target="_blank"
                to={`mailto:${call.contact_email}`}
                onClick={(e) => e.stopPropagation()}
              >
                {call.contact_email}
              </Link>
            )}
            </div>
          )}
        </div>
        <div className="col-misc">
          {(call.origin === "Preventative Maintenance Queue"  && (call?.status?.toLowerCase() !== "completed" && call?.status?.toLowerCase() !=='reschedule')) && (
            <div>
            <Button
              onClick={(e) => {
                cancelPm(call);
                e.stopPropagation();
              }}
              fullWidth
              variant="outlined"
            >
              Cancel PM
            </Button>
          </div>
        )}
        {isAdmin && <div>Assigned To: {assinged_user}</div>}
        {call.time_restriction && (
          <div>
            <AccessTimeFilledIcon color="persiangreen" sx={{ fontSize: 16 }} />{" "}
            Restriction: {call.time_restriction}
          </div>
        )}
        {(call?.status?.toLowerCase() !== "completed" && call?.status?.toLowerCase() !=='reschedule') && (
            <Reschedule call={call} />
        )}
      </div>
    </div>
  );
};

export default ListViewItem;
